import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { getAcademyUrlPublic, getCommunityUrlPublic, getDataSyncAppCollectionUrl, getDataUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getNonProfitsUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const dataHubHref = getDataUrlPublic();
const dataSyncHref = getDataSyncAppCollectionUrl();
const startupsHref = getStartupsUrlPublic('pricing-datapage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-datapage');
export const DataHubFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          dataHubLink: /*#__PURE__*/_jsx(Link, {
            href: dataHubHref,
            external: true,
            onClick: () => handleLinkClick('data.whatIsDataHub', dataHubHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.learnMore"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('data.whatIsDataHub', 'pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataStudio.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataStudio.answer"
      }),
      onExpandedChange: () => handleFaqToggle('data.whatIsDataStudio', 'pricing-page-components.frequentlyAskedQuestions.data.whatIsDataStudio.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataHubVsSmartCRM.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataHubVsSmartCRM.answer"
      }),
      onExpandedChange: () => handleFaqToggle('data.dataHubVsSmartCRM', 'pricing-page-components.frequentlyAskedQuestions.data.dataHubVsSmartCRM.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataConnectionsDifference.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataConnectionsDifference.answer"
      }),
      onExpandedChange: () => handleFaqToggle('data.dataConnectionsDifference', 'pricing-page-components.frequentlyAskedQuestions.data.dataConnectionsDifference.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          dataSyncAppCollection: /*#__PURE__*/_jsx(Link, {
            href: dataSyncHref,
            external: true,
            onClick: () => handleLinkClick('data.thirdPartyApps', dataSyncHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.dataSyncAppCollection"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('data.thirdPartyApps', 'pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.creditBasedPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.creditBasedPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('data.creditBasedPricing', 'pricing-page-components.frequentlyAskedQuestions.data.creditBasedPricing.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: () => handleLinkClick('data.whatSupport.hubSpotCommunity', communityHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: () => handleLinkClick('data.whatSupport.languageOffering', langHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: () => handleLinkClick('data.whatSupport.hubSpotAcademy', academyHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: () => handleLinkClick('data.whatSupport.hubSpotKnowledgeBase', kbHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('data.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.data.whatSupport.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: () => handleLinkClick('data.whatDiscounts.hubSpotForStartups', startupsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.hubSpotForStartups"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: () => handleLinkClick('data.whatDiscounts.hubSpotForNonprofits', nonprofitsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.hubSpotForNonprofits"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('data.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.question')
    })]
  });
};